let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9fQbt")).then(() => parcelRequire('4oP0D'));